/**
 * PageTemplateContext keeps track of whether we have rendered the current page
 * within a template or not, to prevent rendering multiple templates on the same
 * page (which would result in multiple headers and footers, for example)
 */
import * as React from "react";

type PageTemplateContext = {
    hasPageTemplate: boolean;
};

const context: React.Context<PageTemplateContext> =
    React.createContext<PageTemplateContext>({
        hasPageTemplate: false,
    });
context.displayName = "PageTemplateContext";

export default context;
